import {INTERACTION_ID} from './symbols';
import validateSetInteractionIdArguments from './validateSetInteractionIdArguments';

export default function setInteractionId(meta, id) {
	validateSetInteractionIdArguments(meta, 'setInteractionId', id);
	meta[INTERACTION_ID] = id; // eslint-disable-line no-param-reassign
	return meta;
}
